import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    Selection,
    SelectItem,
    SelectionRabListItem,
    SelectionRabListItemName,
    SelectionRabListItemCutName,
} from './SelectionRabItem.style';
import { BetslipRabId } from 'src/domains/sportsbook/betting/models/BetslipIdModels';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface ListItemPropsType {
    rabId: BetslipRabId;
    isSelect: boolean;
    marketName: string;
    marketTemplateType?: string;
    name: string;
    viewName?: string;
    participantName?: string | null | undefined;
    displayName?: boolean;
    borderLeft?: boolean;
    borderRight?: boolean;
}

export const ListItem = observer('ListItem', (props: ListItemPropsType) => {
    const {
        name,
        isSelect,
        participantName,
        marketTemplateType,
        viewName,
        displayName,
        borderLeft,
        borderRight,
        marketName,
        rabId,
    } = props;

    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const onClick = (event: React.SyntheticEvent): void => {
        event.stopPropagation();
        event.preventDefault();

        const rabEvent = rabId.getModel();

        if (isSelect === true) {
            rabEvent.removeSelection(marketName, name);
        } else {
            rabEvent.addSelection(marketName, name);
        }
    };

    return (
        <SelectionRabListItem
            onClick={onClick}
            isSelect={isSelect}
            borderLeft={borderLeft}
            borderRight={borderRight}
            variant={configState.componentVariants.sportsbookVariant}
        >
            {displayName === true ? (
                <SelectionRabListItemName
                    title={name}
                    marketTemplateType={marketTemplateType}
                >
                    {participantName !== null && participantName !== undefined ? (
                        <SelectionRabListItemCutName>{participantName}</SelectionRabListItemCutName>
                    ) : null}
                    {viewName === undefined ? name : viewName}
                </SelectionRabListItemName>
            ) : null}
            <Selection
                isSelect={isSelect}
                variant={configState.componentVariants.sportsbookVariant}
            >
                <SelectItem
                    isSelect={isSelect}
                    variant={configState.componentVariants.sportsbookVariant}
                />
            </Selection>
        </SelectionRabListItem>
    );
});
